exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.requisition-crud .v-select, .requisition-crud .vs__dropdown-toggle {\n    height: auto;\n}\n\n", ""]);

// exports
